<template>
  <div class="report-container">
    <div class="header">
      <h2>智慧考场考生报道</h2>
    </div>
    <div class="content-container">
      <div class="form-container">
        <el-form 
          :model="reportForm" 
          :rules="rules" 
          ref="reportForm" 
          label-width="0px"
          class="report-form"
        >
          <el-form-item prop="idCard">
            <el-input 
              v-model="reportForm.idCard" 
              placeholder="请输入身份证号" 
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="mobile">
            <el-input 
              v-model="reportForm.mobile" 
              placeholder="请输入手机号" 
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="name">
            <el-input 
              v-model="reportForm.name" 
              placeholder="请输入姓名" 
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="photo">
            <el-upload
              action="#"
              :auto-upload="false"
              :show-file-list="true"
              :limit="1"
              accept="image/*"
              :before-upload="$beforeAvatarUpload"
              :http-request="$requestMine"
              :on-change="handlePhotoChange"
              :on-remove="handlePhotoRemove"
              :file-list="photoFileList"
            >
              <el-button type="primary" plain>选择照片</el-button>
              <div slot="tip" class="el-upload__tip">支持 jpg/png，大小≤2MB</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button 
              type="primary" 
              @click="submitForm" 
              class="submit-btn"
              :loading="submitLoading"
            >
              确认报到
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Apply',
  data() {
    return {
      reportForm: {
        idCard: '',
        mobile: '',
        name: '',
        photo: null
      },
      photoFileList: [],
      submitLoading: false,
      rules: {
        idCard: [
          { required: true, validator: this.$validateIdCard, trigger: 'blur' },
        ],
        mobile: [
          { required: true, validator: this.$validatePhone, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        photo: [
          { required: true, message: '请上传照片', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    // 页面初始化时检查参数
    this.checkParams();
  },
  methods: {
    /**
     * 检查参数是否合规
     */
    checkParams() {
      // 从URL获取考试ID和区域ID
      const qrHash = this.$route.query.qrHash;
      if (!qrHash) {
        this.$message.error('二维码信息缺失！');
        // 重新载入当前页面
        return;
      }
    },
    
    /**
     * 提交报到信息
     */
    submitForm() {
      this.$refs.reportForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          
          // 获取URL中的参数
          const qrHash = this.$route.query.qrHash;
          
          // 组装 form-data
          const formData = new FormData();
          formData.append('idCard', this.reportForm.idCard);
          formData.append('name', this.reportForm.name);
          formData.append('mobile', this.reportForm.mobile);
          formData.append('qrHash', qrHash);
          if (this.reportForm.photo) {
            formData.append('photo', this.reportForm.photo);
          }

          // 调用报到接口 - form-data
          this.$Postformat("/biz/isec/exam-apply/apply", formData, 3000, true, 6)
          .then(res => {
            this.submitLoading = false;
            if (res.status === '0') {
              this.$message.success('报到成功');
              // 可以根据需要跳转到其他页面
              // this.$router.replace({ name: 'successPage' });
            } else {
              this.$message.error(res.message || '报到失败');
            }
          }).catch((res) => {
            console.log(res,'--------')
            this.$message.error(res.data ? res.data.message : '服务器异常，稍后再试');
            this.submitLoading = false;
          });
        } else {
          return false;
        }
      });
    },
    // 选择照片
    handlePhotoChange(file, fileList) {
      this.photoFileList = fileList.slice(-1);
      const last = this.photoFileList[0];
      this.reportForm.photo = last ? (last.raw || last) : null;
      // 触发校验
      this.$refs.reportForm && this.$refs.reportForm.validateField('photo');
    },
    // 移除照片
    handlePhotoRemove() {
      this.photoFileList = [];
      this.reportForm.photo = null;
      this.$refs.reportForm && this.$refs.reportForm.validateField('photo');
    }
  }
}
</script>

<style scoped>
.report-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.header {
  text-align: center;
  padding: 20px 0;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.header h2 {
  color: #333;
  font-size: 24px;
  font-weight: bold;
  margin: 0;
}

.content-container {
  padding: 20px;
}

.form-container {
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.report-form /deep/ .el-form-item {
  margin-bottom: 20px;
}

.report-form /deep/ .el-input__inner {
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  padding: 0 15px;
}

.submit-btn {
  width: 100%;
  height: 45px;
  font-size: 18px;
  margin-top: 10px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .content-container {
    padding: 10px;
  }
  
  .form-container {
    padding: 20px;
  }
  
  .header h2 {
    font-size: 20px;
  }
  
  .report-form /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
  
  .submit-btn {
    height: 40px;
    font-size: 16px;
  }
}
</style>